import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { CSSTransition } from "react-transition-group";
import { Form, Progress, Alert } from "reactstrap";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from "./img/logo-medium.png"
import logoSmall from "./img/logo-small.png"
import mifibra_footer from "./img/footer-image.png"

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
    const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'mifibra';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
        cp_convert:parameters.cp_convert
      },
      parameters
    )
    .then((response) => {
      setOnLogin(false)
      window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
    })
    .catch((error) => {
      const _translate = translate(error.errorCode);
      let message= translate("RequestLoginErrorMessage")
      if (_translate) {
        message=_translate;
      } else if (error.details) {
        message=error.details;
      }
      setOnLogin(false)
      setError({ open: true, message })
    });
  }

    return (
      <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="mifibraFormContainer" ref={nodeRef}>
          <img alt="mifibra-logo" src={logo} className="mifibra-logo-medium"/>
        <Form onSubmit={(event) => onSubmit(event)} className="mifibraLoginForm">
          <div className="mifibraLoginForm_msgContainer">
            <p className="mifibraLoginForm_loginMessage">Ingresa tu usuario y contraseña <br/>para iniciar sesión</p>
          </div>
          <div className="mifibraForm">
            <input
              className="mifibra-input"
              disabled={onLogin}
              onChange={e => setUsername(e.target.value)}
              required={true}
              tabIndex={1}
              type="text"
              autoCorrect="off"
              autoCapitalize="none"
              name="login"
              id="login"
              placeholder="Digita tu Nro. de DNI"
            />
            <input
              className="mifibra-input"
              required={true}
              disabled={onLogin}
              onChange={e => setPassword(e.target.value)}
              tabIndex={1}
              type="password"
              autoCorrect="off"
              autoCapitalize="none"
              id="password"
              name="login"
              placeholder="Clave Portal MiFibra"
            />
            <div className="redirectUrl-container">
              <a href="/" className="redirectUrl-container_url">¿Aún no estás registrado?</a>
            </div>
            <>
              {!onLogin ? (
              <button type="submit" className="submitButton" id="entrar" disabled={!props.turnstileSuccess} >
                <span className="submit" id="text">
                  {translate("ButtonEnter")}
                </span>
              </button>
              ) : (
                <Progress animated color="danger" value={100} />
              )}
            </>
            <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
          </div>
        </Form>
        <div className="footerContainer">
          <img src={mifibra_footer} alt={"footer"} className="footerContainer_footer-image"/>
          <div className="footerTextContainer">
            <div className="footerTextContainer_subcontainer">
              <p className="footerTextContainer_text">
                Todos los derechos reservados MiFibra 2023
              </p>
              <p className="footerTextContainer_text">
                Te recordamos que la información solicitada se encuentra bajo el amparo del Secreto de las Telecomunicaciones<br/>
                recogido en el Artículo 2 de la Constitución Política del Perú, la misma que tiene por objetivo brindarte Seguridad y Confidencialidad
              </p>
            </div>
            <div className="footerTextContainer_subcontainer-sm">
              <p className="footerTextContainer_text-sm">
                Todos los derechos reservados MiFibra 2023
              </p>
              <p className="footerTextContainer_text-sm">
                Te recordamos que la información solicitada se encuentra bajo el amparo del Secreto de las Telecomunicaciones recogido en el Artículo 2 de la Constitución Política del Perú, la misma que tiene por objetivo brindarte Seguridad y Confidencialidad
              </p>
            </div>
            <img src={logoSmall} alt={"logo"} className="logo_small"/>
          </div>
        </div>
      </div>
      </CSSTransition>
    );
  }

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
